module.exports = __webpack_public_path__ + "img/psm_login_logo.b880c3fa.png";